import { Box } from '@mui/material';
import { ReactNode } from 'react';

import { SizingMultiplier } from '../sizing-multiplier.constant';

type ListItemActionProps = {
  children?: ReactNode;
};

export const ListItemAction = (props: ListItemActionProps) => {
  const { children } = props;
  return (
    <Box my={-SizingMultiplier.md} mr={-SizingMultiplier.sm}>
      {children}
    </Box>
  );
};
